import React from "react";

export default class Errors extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.errors && this.props.errors.length > 0) {
      const errors = this.props.errors.map((error) => {
        return (
          <li key={error} dangerouslySetInnerHTML={{ __html: error }}></li>
        );
      });

      return (
        <div className="alert alert-danger">
          <ul style={{ margin: 0, padding: "0 1rem" }}>{errors}</ul>
        </div>
      );
    } else {
      return null;
    }
  }
}
